import logo from './logo.svg';
import './App.css';
import React from 'react';
import Header from './components/elements/Header';
import Footer from './components/elements/Footer';
import { AppProvider } from './helpers/AppContext';
import Sidebar from './components/elements/Sidebar';
import Routings from './settings/Routings';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <React.Fragment>
      <ToastContainer />
      <AppProvider>
        <Header/>
        <Sidebar/>
        <Routings/>
        <Footer/>
      </AppProvider>
    </React.Fragment>
  );
}

export default App;